import moment from 'moment-timezone';

export const isFrozen = (startDate: string, endDate: string, freezeDaysNumber: number): boolean => {
  const newStartDate = moment(startDate);
  const countDays = moment(endDate).diff(newStartDate, 'days');
  return countDays <= freezeDaysNumber;
};
